<script>
	// From Lucide
	import { ArrowDown } from 'lucide-svelte';

	export let iconClass = '';
</script>

<ArrowDown class={iconClass} />
